import React from 'react';

export const StatBox = ({ label, value, suffix, icon, color = 'cyan', change, gradient }) => {
  return (
    <div className={`stat-box ${color}`}>
      <div className="stat-label">
        {icon && <span className="stat-icon">{icon}</span>}
        {label}
      </div>
      <div className={`stat-value ${gradient ? 'gradient' : ''}`}>
        {value}
        {suffix && <span className="stat-suffix">{suffix}</span>}
      </div>
      {change && <div className="stat-change">{change}</div>}
    </div>
  );
};

export const EmptyState = ({ icon = '📭', title = 'Nothing here yet', text }) => (
  <div className="empty">
    <div className="empty-icon">{icon}</div>
    <div className="empty-title">{title}</div>
    {text && <div className="empty-text">{text}</div>}
  </div>
);

export const ProgressBar = ({ percent, showLabel }) => {
  const p = Math.min(100, Math.max(0, percent));
  return (
    <div>
      <div className="progress-bar">
        <div className="progress-fill" style={{ width: `${p}%` }} />
      </div>
      {showLabel && (
        <div style={{ fontSize: 11, color: 'var(--text-tertiary)', marginTop: 4, textAlign: 'right' }}>
          {p.toFixed(1)}%
        </div>
      )}
    </div>
  );
};

export const Alert = ({ type = 'info', icon, children }) => {
  const defaultIcons = { info: 'ℹ️', warning: '⚠️', error: '⛔', success: '✅' };
  return (
    <div className={`alert alert-${type}`}>
      <div className="alert-icon">{icon || defaultIcons[type]}</div>
      <div>{children}</div>
    </div>
  );
};
